/* eslint-disable react/no-array-index-key */
import { memo, useState } from 'react';
import styles from './FlexibleRequestDetailsTable.module.scss';
import { RequestField, SupportedLanguages, createTableRows } from './service';

type Props = {
  defaultRenderLine: number;
  language: SupportedLanguages;
  requestFields: Array<RequestField>;
};

const TRANSLATIONS = {
  en: {
    readLess: 'Close',
    readMore: 'Read More',
  },
  ja: {
    readLess: '閉じる',
    readMore: 'もっと読む',
  },
};

const createListForDisplay = (
  requestFields: Array<RequestField>,
  language: SupportedLanguages
): Array<{ label: string; value: string }> => {
  const tableRows = createTableRows(requestFields, language);
  return tableRows.map((item) => ({
    label: item.fieldLabel,
    value: item.fieldValue,
  }));
};

const shouldRenderLine = (
  currentLine: number,
  defaultRenderLine: number,
  isExpanded: boolean
): boolean => {
  if (isExpanded) return true;
  if (currentLine <= defaultRenderLine) return true;
  return false;
};

const FlexibleRequestDetailsTable = memo((props: Props) => {
  const [isExpanded, setExpanded] = useState(false);
  const { defaultRenderLine, language, requestFields } = props;
  const expandHundler = () => {
    setExpanded((prev) => !prev);
  };

  const displayItemList = createListForDisplay(requestFields, language);

  return (
    <div className={styles['request-detail-container']}>
      <h4 className={styles['caption']}>{language === 'ja' ? '依頼の詳細' : 'Request Details'}</h4>
      <div className={styles['request-detail-table-container']}>
        {displayItemList.map(
          (displayItem, index) =>
            shouldRenderLine(index + 1, defaultRenderLine, isExpanded) && (
              <div
                className={styles['request-detail-table']}
                key={`request-details-table-${index}`}
              >
                <div className={styles['request-detail-label']}>{displayItem.label}</div>
                <div className={styles['request-detail-value']}>{displayItem.value}</div>
              </div>
            )
        )}
      </div>
      <button onClick={expandHundler} className={styles['read-switch']}>
        {isExpanded ? TRANSLATIONS[language].readLess : TRANSLATIONS[language].readMore}
      </button>
    </div>
  );
});

FlexibleRequestDetailsTable.displayName = 'FlexibleRequestDetailsTable';

export { FlexibleRequestDetailsTable };
